@if (currentJob(); as j) {
  <div
    class="flex flex-col gap-2 rounded-lg border border-blue-200 bg-blue-50 p-3 text-sm sm:flex-row sm:items-center sm:justify-between"
    role="status"
    data-testid="job-context-bar"
  >
    <div class="flex items-center gap-2 min-w-0">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.75"
        stroke="currentColor"
        class="h-4 w-4 flex-shrink-0 text-blue-700"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
        />
      </svg>
      <span class="truncate text-blue-900" [attr.title]="label()">
        Filtered to: <strong class="font-semibold">{{ label() }}</strong>
      </span>
    </div>
    <button
      type="button"
      (click)="onClear()"
      class="inline-flex items-center gap-1 self-start rounded-md border border-blue-300 bg-white px-2 py-1 text-xs font-medium text-blue-700 hover:bg-blue-100 sm:self-auto"
      data-testid="clear-job-filter"
    >
      Clear
      <span aria-hidden="true">×</span>
    </button>
  </div>
}
